export let serverURL = process.env.REACT_APP_DEFAULT_IMAGE_URL;
